import { render, staticRenderFns } from "./globalnode.vue?vue&type=template&id=43b80d24&"
import script from "./globalnode.vue?vue&type=script&lang=js&"
export * from "./globalnode.vue?vue&type=script&lang=js&"
import style0 from "./globalnode.vue?vue&type=style&index=0&id=43b80d24&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports